import React from "react";
import { Styled } from "./404.styled";

const Page404: React.FC = () => {
  return <Styled.Wrapper404 color={"green"}>Page not found</Styled.Wrapper404>;
};

export default Page404;
